export default "__VITE_ASSET__B3ivnD5p__"